<template>
  <div class="appBottomMenu">
    <!-- <router-link class="item" active-class='active' to="/"> -->
    <a class="item" href="/">
      <div class="col">
        <ion-icon name="file-tray-full-outline"></ion-icon>
        <strong>بار های جدید</strong>
      </div>
    </a>
    <!-- <router-link class="item" active-class='active' to="/chatbubbles" data-bs-toggle="offcanvas" data-bs-target="#actionSheetShare">
      <div class="col">
        <ion-icon name="chatbubbles-outline"></ion-icon>
        <strong>پشتیبانی</strong>
      </div>
    </router-link> -->
        <router-link class="item" active-class='active' to="/myCargos">
          <div class="col">
            <ion-icon name="archive-outline"></ion-icon>
            <strong>بارهای من</strong>
          </div>
        </router-link>
        <router-link class="item" active-class='active' to="/profile">
          <div class="col">
            <ion-icon name="people-outline"></ion-icon>
            <strong>پروفایل</strong>
          </div>
        </router-link>
  </div>
</template>

<script>
export default {
  name: "footer"
}
</script>

<style></style>